import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { GetPerformanceQuery, PerformanceFormFillsDataResponse } from '../types';
import { usePerformanceFormFillsRequest } from './usePerformanceRequests';

const useGetFormFillTAT = (query?: GetPerformanceQuery) => {
    const [processedData, setProcessedData] =
        React.useState<PerformanceFormFillsDataResponse['tat_reports']>();
    const { data } = usePerformanceFormFillsRequest(query);

    const [searchParams] = useSearchParams();
    const state = searchParams.get('state');

    React.useEffect(() => {
        if (!data) return;

        const filteredData = state
            ? data.tat_reports.filter((item) => state.split(',').includes(item.state))
            : data.tat_reports;

        const calculatedData = filteredData.reduce((acc, row) => {
            const existingWeek = acc.find(
                (item: PerformanceFormFillsDataResponse['tat_reports'][number]) =>
                    item.week_start === row.week_start
            );

            if (existingWeek) {
                existingWeek.count += 1;
                existingWeek.enrolled_form_fills += row.enrolled_form_fills;
                existingWeek.average_tat_to_enroll_days += row.average_tat_to_enroll_days;
            } else {
                acc.push({
                    count: 1,
                    state: '',
                    week_start: row.week_start,
                    week_end: row.week_end,

                    enrolled_form_fills: row.enrolled_form_fills,
                    average_tat_to_enroll_days: row.average_tat_to_enroll_days
                });
            }

            return acc;
        }, [] as (PerformanceFormFillsDataResponse['tat_reports'][number] & { count: number })[]);

        // Calculate averages
        for (const row of calculatedData) {
            row.average_tat_to_enroll_days = row.average_tat_to_enroll_days / row.count || 0;
        }

        calculatedData.sort(
            (a, b) => new Date(a.week_start).getTime() - new Date(b.week_start).getTime()
        );

        setProcessedData(calculatedData);
    }, [data, state]);

    return processedData || undefined;
};

export default useGetFormFillTAT;
